import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import ElementUI from 'element-ui';

import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale });

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

//import { Loading } from 'element-ui';

//Vue.use(Loading.directive);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
	events: "blur"
});

Vue.config.productionTip = false;


function parseHtml(check) {
  //console.log(check)
  const regex = /{{[a-zA-Z0-9_?. ]+:[a-zA-Z0-9_?. ]+}}/g;
  let test = check.match(regex);
  if (test && test.length > 0) {
    _.each(test,
      t => {

        // remove curly
        const x = t.replace("{{", "").replace("}}", "");
        const parts = x.split(":");
        const modal = parts[0];
        const text = parts[1];
        check = check.replace(t,
          '<a class="text-primary" data-modal="' + modal + '" onclick="loadModal(this)">' + text + '</a>');
      });
  }


  return check;
}

Vue.prototype.$parseHtml = parseHtml;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount(window.sunstonevNext.apps.signup.data.appId);


